import * as React from 'react';

function SvgShadowNone(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={15} height={15} viewBox="0 0 15 15" {...props}>
      <path
        fillRule="evenodd"
        d="M11.216 2.017a6.623 6.623 0 00-9.199 9.199l.686-.687a5.673 5.673 0 017.827-7.827l.685-.685zm1.767 1.768l-.686.686a5.673 5.673 0 01-7.826 7.826l-.686.686a6.623 6.623 0 009.199-9.199zM7.5 9.9a.4.4 0 01-.374-.258l.542-.542h2.982a.4.4 0 010 .8H7.5zm1.368-2H11.7a.4.4 0 000-.8H9.668l-.8.8zM7.5 5.1h.632l-.774.774A.4.4 0 017.5 5.1zm-.4-1.6c0-.22.18-.4.4-.4h1.398a.4.4 0 110 .8H7.5a.4.4 0 01-.4-.4zm0 8c0-.22.18-.4.4-.4h1.398a.4.4 0 010 .8H7.5a.4.4 0 01-.4-.4zm6.254-9.146a.5.5 0 00-.707-.708l-11 11a.5.5 0 10.707.708l11-11z"
      />
    </svg>
  );
}

export default SvgShadowNone;
